import get from 'lodash/get';
import trim from 'lodash/trim';
const withPrefix = require('./withPrefix').default;

export default function PostUrl(post) {
	const slug = trim(get(post, 'slug'), '/');
	return withPrefix(`/blog/${slug}`);
}
